











import { Vue, Component } from 'vue-property-decorator';
@Component
export default class FormButtons extends Vue {
  private handleSearch() {
    this.$emit('handle-search');
  }
  
  private handleReset() {
    this.$emit('handle-reset');
  }
}
